import React, { useState } from "react";
import { Button } from "../ButtonElements";

import {
  HeroContainer,
  Wrapper,
  HeroContent,
  HeroH1,
  HeroP,
  HeroBg,
  VideoBg,
  HeroBtnWrapper,
  ArrowForward,
  ArrowRight,
} from "./HeroElements";
import Video from "../../videos/video3.mp4";

const HeroSection = () => {
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(!hover);
  };

  return (
    <HeroContainer>
      <HeroBg>
        <VideoBg autoPlay loop muted src={Video} type="video/mp4" />
      </HeroBg>

      <HeroContent>
        <HeroH1>आशा नेपाल</HeroH1>
        <HeroP>
          CONSULT WITH MENTAL HEALTH PROFESSIONAL TO GET YOURSELF A RELIEF
        </HeroP>
        <HeroBtnWrapper>
          <Button
            to="about"
            onMouseEnter={onHover}
            onMouseLeave={onHover}
            primary="true"
            dark="true"
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
          >
            GET STARTED{hover ? <ArrowForward /> : <ArrowRight />}
          </Button>
          <HeroP>
            There is hope,even when your brain tells you there isn't.
          </HeroP>
        </HeroBtnWrapper>
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection;
